// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var FileList_file_graphql = require("../../../__generated__/FileList_file_graphql.bs.js");
var FileList_files_graphql = require("../../../__generated__/FileList_files_graphql.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");

var convertFragment = FileList_file_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, FileList_file_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(FileList_file_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, FileList_file_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(FileList_file_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function FileList$File(props) {
  var file = use(props.file);
  var match = file.contentType;
  var tmp;
  switch (match) {
    case "application/pdf" :
        tmp = "FilePdf";
        break;
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document" :
        tmp = "FileDoc";
        break;
    default:
      tmp = "File";
  }
  return JsxRuntime.jsxs("a", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Icon__Jsx3.make, {
                            icon: tmp,
                            className: "text-gray-400 group-hover:text-blue-300",
                            size: 48
                          })
                    }),
                JsxRuntime.jsx("div", {
                      children: file.fileName,
                      className: "font-medium text-gray-700 text-center line-clamp-2 overflow-hidden break-all"
                    })
              ],
              className: "border rounded-lg py-6 px-2 flex flex-col items-center gap-4 group\n      hover:border-blue-300 group w-40\n      ",
              href: file.url,
              target: "_blank"
            });
}

var $$File = {
  Fragment: Fragment,
  make: FileList$File
};

var convertFragment$1 = FileList_files_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, FileList_files_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(FileList_files_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(fRef) : undefined, FileList_files_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(FileList_files_graphql.node, convertFragment$1, fRef);
}

var Fragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function $$FileList(props) {
  var __showTitle = props.showTitle;
  var showTitle = __showTitle !== undefined ? __showTitle : true;
  var files = use$1(props.files);
  return JsxRuntime.jsxs("div", {
              children: [
                showTitle ? JsxRuntime.jsx("h2", {
                        children: "Files",
                        className: "text-2xl font-medium text-gray-800"
                      }) : null,
                JsxRuntime.jsx("div", {
                      children: files.map(function (file) {
                            return JsxRuntime.jsx(FileList$File, {
                                        file: file.fragmentRefs
                                      });
                          }),
                      className: "flex gap-8 flex-wrap"
                    })
              ],
              className: "flex flex-col gap-4"
            });
}

var make = $$FileList;

exports.$$File = $$File;
exports.Fragment = Fragment$1;
exports.make = make;
/* Icon__Jsx3 Not a pure module */
